import { calculateFocusPointScreenPosition as e, clickToFocusPoint as t, constrainFocusPointToVisibleArea as n, decomposeCropArea as r, updateConstrainedFocusPoint as i, wheelEventToZoomFactor as a } from "./softcrop-lib.es.js";
import { DragHandle as o } from "./DragHandle.es.js";
import { forwardRef as s, useCallback as c, useEffect as l, useImperativeHandle as ee, useRef as u, useState as d } from "react";
import { FocusIcon as f } from "lucide-react";
import { Fragment as te, jsx as p, jsxs as m } from "react/jsx-runtime";
//#region lib/components/CropDialog/Softcrop.tsx
var h = s(({ src: s, children: h, maxZoom: g = 5, zoomSensitivity: _ = .02, onChange: v, onReady: y, enableFocusPoint: b = !0, enableDragHandles: x = !0, enablePanAndZoom: S = !0 }, ne) => {
	let C = u(null), w = u(null), T = u(null), E = u(null), [D, re] = d(!1), [O, k] = d({
		width: 0,
		height: 0
	}), [A, j] = d({
		width: 0,
		height: 0
	}), [M, N] = d(null), [P, F] = d(!1), [ie, I] = d(!1), [L, R] = d({
		x: 0,
		y: 0
	}), [z, B] = d({
		x: 0,
		y: 0,
		w: 1,
		h: 1
	}), [V, H] = d({
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	}), U = c(() => ({
		width: A.width,
		height: O.width > 0 ? A.width * (O.height / O.width) : 0
	}), [A.width, O]), W = D && A.width > 0 && A.height > 0 && O.width > 0 && O.height > 0, G = c(() => {
		if (!W) return {
			scale: 1,
			position: {
				x: 0,
				y: 0
			}
		};
		let e = U(), t = A.width / (z.w * e.width), n = A.height / (z.h * e.height), r = Math.min(t, n), i = z.w * e.width * r, a = z.h * e.height * r;
		return {
			scale: r,
			position: {
				x: (A.width - i) / 2 - z.x * e.width * r,
				y: (A.height - a) / 2 - z.y * e.height * r
			}
		};
	}, [
		W,
		z,
		A,
		U
	]), K = c(() => {
		if (!W) return null;
		let e = {
			x: z.x + z.w * V.left,
			y: z.y + z.h * V.top,
			w: z.w * (1 - V.left - V.right),
			h: z.h * (1 - V.top - V.bottom)
		};
		return e.w <= 0 || e.h <= 0 ? null : (e.x = Math.max(0, Math.min(1, e.x)), e.y = Math.max(0, Math.min(1, e.y)), e.w = Math.max(0, Math.min(1 - e.x, e.w)), e.h = Math.max(0, Math.min(1 - e.y, e.h)), {
			x: Number(e.x.toFixed(5)),
			y: Number(e.y.toFixed(5)),
			w: Number(e.w.toFixed(5)),
			h: Number(e.h.toFixed(5))
		});
	}, [
		z,
		V,
		W
	]), ae = c(() => {
		if (!T.current) return;
		let e = {
			width: T.current.naturalWidth,
			height: T.current.naturalHeight
		};
		k(e), re(!0);
	}, []);
	l(() => {
		W && setTimeout(() => y?.(), 0);
	}, [W, y]), l(() => {
		if (!C.current || !w.current) return;
		let e = () => {
			if (!C.current || !w.current) return;
			let e = C.current.offsetWidth, t = C.current.offsetHeight;
			j({
				width: e,
				height: t
			}), w.current.style.height = t + "px";
		};
		e();
		let t = new ResizeObserver(e);
		return t.observe(C.current), () => t.disconnect();
	}, []), l(() => {
		if (!(!D || A.width === 0 || !w.current) && A.height === 0 && O.width > 0) {
			let e = O.height / O.width, t = A.width * e;
			w.current.style.height = t + "px", j((e) => ({
				...e,
				height: t
			}));
		}
	}, [
		D,
		A.width,
		A.height,
		O
	]), l(() => {
		if (!w.current) return;
		let e = (e) => {
			if (!S) return;
			e.preventDefault(), e.stopPropagation();
			let t = a(e.deltaY, _), n = C.current?.getBoundingClientRect();
			if (!n) return;
			let r = (e.clientX - n.left) / A.width, i = (e.clientY - n.top) / A.height;
			B((e) => {
				let n = e.w / t, a = e.h / t, o = 1 / g;
				n = Math.max(o, Math.min(1, n)), a = Math.max(o, Math.min(1, a));
				let s = e.x + (e.w - n) * r, c = e.y + (e.h - a) * i;
				return {
					x: Math.max(0, Math.min(1 - n, s)),
					y: Math.max(0, Math.min(1 - a, c)),
					w: n,
					h: a
				};
			});
		}, t = w.current;
		return t.addEventListener("wheel", e, { passive: !1 }), () => {
			t.removeEventListener("wheel", e);
		};
	}, [
		A,
		g,
		_
	]);
	let oe = c((e) => {
		e.preventDefault(), F(!0), R({
			x: e.clientX,
			y: e.clientY
		});
	}, []), se = c((e) => {
		if (!P || !S) return;
		e.preventDefault(), I(!0);
		let t = e.clientX - L.x, n = e.clientY - L.y, r = U(), { scale: i } = G(), a = -t / (r.width * i), o = -n / (r.height * i);
		B((e) => {
			let t = Math.max(0, Math.min(1 - e.w, e.x + a)), n = Math.max(0, Math.min(1 - e.h, e.y + o));
			return {
				...e,
				x: t,
				y: n
			};
		}), R({
			x: e.clientX,
			y: e.clientY
		});
	}, [
		P,
		L,
		U,
		G
	]), ce = c((e) => {
		if (F(!1), !ie) {
			let n = e.clientX - L.x, r = e.clientY - L.y;
			if (!C.current || Math.abs(n) > 3 || Math.abs(r) > 3) return;
			let i = C.current.getBoundingClientRect(), { scale: a, position: o } = G(), s = t({
				x: e.clientX,
				y: e.clientY
			}, i, a, o, U());
			s && N({
				x: Number(s.x.toFixed(5)),
				y: Number(s.y.toFixed(5))
			});
		}
		I(!1);
	}, [
		L,
		G,
		U
	]), le = c((e) => {
		if (e.touches.length === 2) return;
		let t = e.touches;
		e.preventDefault(), F(!0), R({
			x: t[0].clientX,
			y: t[0].clientY
		});
	}, []), ue = c((e) => {
		if (!S || !P) return;
		I(!0), e.preventDefault();
		let t = e.touches[0].clientX - L.x, n = e.touches[0].clientY - L.y, r = U(), { scale: i } = G(), a = -t / (r.width * i), o = -n / (r.height * i);
		B((e) => {
			let t = Math.max(0, Math.min(1 - e.w, e.x + a)), n = Math.max(0, Math.min(1 - e.h, e.y + o));
			return {
				...e,
				x: t,
				y: n
			};
		}), R({
			x: e.touches[0].clientX,
			y: e.touches[0].clientY
		});
	}, [
		P,
		L,
		U,
		G
	]), de = c(() => {
		F(!1), setTimeout(() => {
			I(!1);
		}, 0);
	}, []), q = M ? (() => {
		let { scale: t, position: r } = G(), a = e(M, t, r, U()), o = n(a, A, 40);
		if (a.x !== o.x || a.y !== o.y) {
			let e = i(o, t, r, U());
			setTimeout(() => {
				N({
					x: Number(e.x.toFixed(5)),
					y: Number(e.y.toFixed(5))
				});
			}, 0);
		}
		return o;
	})() : null, J = (e) => typeof e == "number" && e >= 0 && e <= 1 && isFinite(e), Y = c((e, t) => {
		H((n) => ({
			...n,
			[e]: t
		}));
	}, []), X = c((e) => V[e], [V]), Z = c((e) => {
		switch (e) {
			case "top": return V.bottom;
			case "right": return V.left;
			case "bottom": return V.top;
			case "left": return V.right;
		}
	}, [V]), Q = c(() => V, [V]);
	l(() => {
		!v || !W || v(K(), b ? M : null);
	}, [
		z,
		V,
		M,
		v,
		W,
		K
	]);
	let { scale: fe, position: $ } = G();
	return ee(ne, () => ({
		getCropArea: () => K(),
		getFocusPoint: () => b ? M : null,
		getCropOffsets: Q,
		setCropArea: (e, t, n, i) => {
			if (!J(e) || !J(t) || !J(n) || !J(i)) {
				console.warn("Invalid crop area coordinates", {
					x: e,
					y: t,
					w: n,
					h: i
				});
				return;
			}
			let a = r(A, {
				x: e,
				y: t,
				w: n,
				h: i
			});
			B(a.baseCrop), H(a.dragOffsets);
		},
		setFocusPoint: (e, t) => {
			if (!J(e) || !J(t)) {
				console.warn("Invalid focus point coordinates", {
					x: e,
					y: t
				});
				return;
			}
			N({
				x: Number(e.toFixed(5)),
				y: Number(t.toFixed(5))
			}), E.current && (E.current.style.display = "flex");
		},
		setCropOffsets: (e) => H(e),
		zoomIn: () => {
			let e = (1 + _) ** 3;
			B((t) => {
				let n = Math.max(1 / g, t.w / e), r = Math.max(1 / g, t.h / e);
				return {
					x: Math.max(0, Math.min(1 - n, t.x + (t.w - n) / 2)),
					y: Math.max(0, Math.min(1 - r, t.y + (t.h - r) / 2)),
					w: n,
					h: r
				};
			});
		},
		zoomOut: () => {
			let e = (1 + _) ** -3;
			B((t) => {
				let n = Math.min(1, t.w / e), r = Math.min(1, t.h / e);
				return {
					x: Math.max(0, Math.min(1 - n, t.x + (t.w - n) / 2)),
					y: Math.max(0, Math.min(1 - r, t.y + (t.h - r) / 2)),
					w: n,
					h: r
				};
			});
		},
		reset: () => {
			B({
				x: 0,
				y: 0,
				w: 1,
				h: 1
			}), H({
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}), N(null), E.current && (E.current.style.display = "none");
		}
	}), [
		z,
		V,
		M,
		K,
		Q,
		_,
		g,
		A
	]), /* @__PURE__ */ m("div", {
		ref: C,
		contentEditable: !1,
		className: "absolute top-0 left-0 w-full h-full rounded-lg overflow-hidden",
		children: [
			/* @__PURE__ */ m("div", {
				ref: w,
				className: "relative overflow-hidden w-full cursor-grab active:cursor-grabbing",
				onMouseDown: oe,
				onMouseMove: se,
				onMouseUp: ce,
				onMouseLeave: () => {
					I(!1), F(!1);
				},
				onTouchStart: le,
				onTouchMove: ue,
				onTouchEnd: de,
				style: { touchAction: "none" },
				children: [/* @__PURE__ */ p("img", {
					ref: T,
					src: s,
					onLoad: ae,
					className: "block absolute select-none",
					style: {
						transform: `translate(${$.x}px, ${$.y}px) scale(${fe})`,
						transformOrigin: "0 0",
						width: U().width || "auto",
						height: U().height || "auto"
					}
				}), q && b && /* @__PURE__ */ p("div", {
					ref: E,
					className: "absolute top-0 left-0 w-[40px] h-[40px] rounded-[12px] pointer-events-none",
					style: {
						transform: `translate(${q.x - 20}px, ${q.y - 20}px)`,
						boxShadow: "rgba(0, 0, 0, 0.35) 0px 0px 20px 0px",
						borderRadius: "12px",
						backgroundColor: "rgba(0, 0, 0, 0.15)",
						display: "flex"
					},
					children: /* @__PURE__ */ p(f, {
						color: "rgba(255, 255, 255, 0.9)",
						className: "w-[40px] h-[40px] rounded-[12px] flex items-center justify-center"
					})
				})]
			}),
			x && /* @__PURE__ */ m(te, { children: [
				/* @__PURE__ */ p(o, {
					side: "top",
					offset: X("top"),
					opposite: Z("top"),
					onChange: (e) => Y("top", e),
					size: A.height
				}),
				/* @__PURE__ */ p(o, {
					side: "right",
					offset: X("right"),
					opposite: Z("right"),
					onChange: (e) => Y("right", e),
					size: A.width
				}),
				/* @__PURE__ */ p(o, {
					side: "bottom",
					offset: X("bottom"),
					opposite: Z("bottom"),
					onChange: (e) => Y("bottom", e),
					size: A.height
				}),
				/* @__PURE__ */ p(o, {
					side: "left",
					offset: X("left"),
					opposite: Z("left"),
					onChange: (e) => Y("left", e),
					size: A.width
				})
			] }),
			h
		]
	});
});
h.displayName = "Softcrop";
//#endregion
export { h as Softcrop };
